import { useCallback, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useForm } from '../forms/useForm';
import { useSweetAlert } from '../sweetAlerts/useSweetAlert';
import { validarSesion } from '../tokens/useToken';
import { ModalCreateSpecimenProvenances, ModalUpdateSpecimenProvenances, ModalDeleteSpecimenProvenances, LostConnection } from '../../constant';
import { sendRequest } from '../requests/useRequest';

export const useSpecimenProvenances = ({activeTab}) => {
    
    const history = useHistory();

    const [specimenProvenances, setSpecimenProvenances] = useState([]);
    const [specimenProvenancesId, setSpecimenProvenancesId] = useState(0);

    const [method, setMethod] = useState("");
    const [modal, setModal] = useState(false);
    const [modalTitle, setModalTitle] = useState("");

    const [loading, setLoading] = useState(false);
    const [createSweet] = useSweetAlert();
    // ? Delete dialog
    const [modalAlert, setModalAlert] = useState(false);
    const [showDeleteAlert, setShowDeleteAlert] = useState(false);

    const [loadingExcel, setLoadingExcel] = useState(false);
    const [searchSpecimenProvenances, setSearchSpecimenProvenances] = useState("");
    const [specimenBackup, setSpecimenBackup] = useState([]);
        
    const [formValues, handleInputChange, reset, handleUpdateValues] = useForm({
        name: "",
        abbreviation: ""
    });

    const {
        name, abbreviation
    } = formValues;

    const [validaciones, setValidaciones] = useState({
        name_valid: false,
        abbreviation: false
    });

    const openDialog = (title, mode) => {
        setModalTitle(title);
        setMethod(mode);
        setModal(true);
    };

    const closeDialog = () => {
        setModal(false);
    };

   
     const openDeleteAlert = () => {
        setShowDeleteAlert(true); 
        setModalAlert(true);  
    };

    const closeDeleteAlert = () => {
        setShowDeleteAlert(false); 
        setModalAlert(false);   
    };

    useEffect(() => {

        getSpecimenProvenances();

    }, [activeTab])

    const getSpecimenProvenances = useCallback(async () => {
        let requestOptions = {
            method: 'GET'
        };

        const respuesta = await sendRequest(requestOptions, "SpecimenProvenances/List");

        if (respuesta.code === 200) {
            let listSpecimenProvenances = [];

            if (respuesta.data.length >= 1) {

                respuesta.data.forEach( (data) => {
                    listSpecimenProvenances.push({
                        id_specimen_provenance: data.id_specimen_provenance,
                        name: data.name,
                        abbreviation: data.abbreviation
                    });
                });
                
                setSpecimenProvenances(listSpecimenProvenances);
                setSpecimenBackup(listSpecimenProvenances); 
            }
            else{
                createSweet("error", "error", "Hubo un error!", "No se encontraron datos");
                setSpecimenProvenances([]);
            }
        }
        else{
            validarSesion(history, respuesta.code, getSpecimenProvenances);
        }
    }, [history]);

    useEffect(() => {
        
        getSpecimenProvenances();

    }, [getSpecimenProvenances]);

    const handleCreate = () => {
        handleUpdateValues({
            name: "",
            abbreviation: ""
        });

        setValidaciones({
            name_valid: false,
            abbreviation_valid: false
        });

        setSpecimenProvenancesId(0);
        setMethod("create");
        setModalTitle(ModalCreateSpecimenProvenances);
        openDialog("Crear procedencia del especímen", "create");
    }

    const saveCreate = async (e) => {
        e.preventDefault();

        setLoading(true);

        if (validarForm()) {
            setLoading(false);
            return;
        }

        let mValues = JSON.stringify(formValues);
        let requestOptions = {
            method: 'POST',
            body: mValues
        };

        const respuesta = await sendRequest(requestOptions, "SpecimenProvenances");
        if (respuesta.code === 200) {
            getSpecimenProvenances();
            reset();
            createSweet("create", "success", "Exito!", "Procedencia creada con exito");
            setLoading(false);
            closeDialog();
        }
        else if (respuesta.code === 401) {
            setLoading(false);
            validarSesion(history, respuesta.code, saveCreate);
        }
        else if(respuesta.code === 500){
            setLoading(false);
            createSweet("error", "error", "Especímen", "Ocurrio un problema en el servidor");
        }
        else{
            setLoading(false);
            createSweet("error", "warning", "Especímen", respuesta.data.msg);
        }
    }

    const handleUpdate = (id_specimen_provenance) => {
        let specimenProvenance = specimenProvenances.find(sp => sp.id_specimen_provenance === id_specimen_provenance);

        handleUpdateValues({
            name: specimenProvenance.name,
            abbreviation: specimenProvenance.abbreviation
        });

        setValidaciones({
            name_valid: false,
            abbreviation_valid: false
        });

        setSpecimenProvenancesId(id_specimen_provenance);
        setMethod("update");
        setModalTitle(ModalUpdateSpecimenProvenances);
        openDialog("Editar procedencia","update");
    }

    const saveUpdate = async (e) => {
        e.preventDefault();

        setLoading(true);

        if (validarForm()) {
            setLoading(false);
            return;
        }

        let body = {
            id_specimen_provenance: specimenProvenancesId,
            ...{ ...formValues }
        };
        let mValues = JSON.stringify(body);

        let requestOptions = {
            method: 'PUT',
            body: mValues
        };

        const respuesta = await sendRequest(requestOptions, "SpecimenProvenances/Update");
        
        if (respuesta.code === 200) {
            getSpecimenProvenances();
            createSweet("create", "success", "Exito!", "Procedencia actualizada");
            setLoading(false);
            closeDialog();
        }
        else if (respuesta.code === 401) {
            validarSesion(history, respuesta.code, saveUpdate);
        }
        else if(respuesta.code === 500){
            createSweet("error", "error", "Especímen", "Ocurrio un problema en el servidor");
        }
        else{
            createSweet("error", "warning", "Especímen", respuesta.data.msg);
        }
    }

    const handleDelete = (id_specimen_provenance) => {
        let specimenProvenance = specimenProvenances.find(sp => sp.id_specimen_provenance === id_specimen_provenance);

        handleUpdateValues({
            name: specimenProvenance.name,
            abbreviation: specimenProvenance.abbreviation
        });

        setSpecimenProvenancesId(id_specimen_provenance);
        setMethod("delete");
        setModalTitle(ModalDeleteSpecimenProvenances);
        openDeleteAlert();
    }

    const saveDelete = async (e) => {
        e.preventDefault();

        setLoading(true);

        let requestOptions = {
            method: 'DELETE'
        };

        const respuesta = await sendRequest(requestOptions, `SpecimenProvenances/${specimenProvenancesId}`);

        if (respuesta.code === 200) {
            getSpecimenProvenances();
            setLoading(false);
            createSweet("create", "success", "Exito!", "Procedencia eliminada");
            closeDeleteAlert();
        }
        else if (respuesta.code === 401) {
            setLoading(false)
            validarSesion(history, respuesta.code, saveDelete);
        }
        else if(respuesta.code === 500){
            setLoading(false)
            createSweet("error", "error", "Especímen", "Ocurrio un problema en el servidor");
        }
        else{
            setLoading(false);
            createSweet("error", "warning", "Especímen", respuesta.data.msg);
        }
    }

    const validarForm = () => {
        let statusValidation = false;
        let newValidations = {};

        if (formValues.name.length < 3) {
            newValidations = {
                ...newValidations,
                name_valid: true
            };
            statusValidation = true;
        }
        else{
            newValidations = {
                ...newValidations,
                name_valid: false
            };
        }

        if (formValues.abbreviation.length < 2) {
            newValidations = {
                ...newValidations,
                abbreviation_valid: true
            };
            statusValidation = true;
        }
        else{
            newValidations = {
                ...newValidations,
                abbreviation_valid: false
            };
        }

        setValidaciones(newValidations);

        return statusValidation;
    }

    const handleExcelProvenanceSpecimen = async () => {
        setLoadingExcel(true);

        try {
            const XLSX = await import("xlsx");

            const data = specimenProvenances.map((item, index) => ({
                "#": index + 1,
                "Nombre": item.name || "----",
                "Abreviatura": item.abbreviation || "----"
            }));

            const worksheet = XLSX.utils.json_to_sheet(data);

            // tamaños de columnas
            worksheet["!cols"] = [
                { wch: 5 },
                { wch: 40 },
                { wch: 20 }
            ];

            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Procedencias");

            const excelBuffer = XLSX.write(workbook, {
                bookType: "xlsx",
                type: "array"
            });

            const blob = new Blob([excelBuffer], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            });

            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = "Procedencias_Especimen.xlsx";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

        } catch (error) {
            console.error("Error al exportar Excel", error);
        }

        setLoadingExcel(false);
    };

    const handleSearchProvenacesSpecimen = (value) => {

        const text = typeof value === "string"
            ? value
            : value?.target?.value || "";

        setSearchSpecimenProvenances(text);

        if (text === "") {
            setSpecimenProvenances(specimenBackup);
            return;
        }

        const filtered = specimenBackup.filter(item =>
            item.name?.toUpperCase().includes(text.toUpperCase()) ||
            item.abbreviation?.toUpperCase().includes(text.toUpperCase())
        );

        setSpecimenProvenances(filtered);
    };

    const handleClearProvenancesSpecimen = () => {
        setSearchSpecimenProvenances("");
        setSpecimenProvenances(specimenBackup);
    };

    return {
        specimenProvenances, method,
        name, abbreviation,
        handleInputChange, validaciones,
        closeDialog, modal, modalTitle, loading,
        handleCreate, saveCreate,
        handleUpdate, saveUpdate,
        handleDelete, saveDelete,
        closeDeleteAlert, modalAlert, showDeleteAlert,
        loadingExcel, handleExcelProvenanceSpecimen, 
        handleSearchProvenacesSpecimen, handleClearProvenancesSpecimen
    }
}
